import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MinusIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.minusIcon}`}
        data-testid={testId}
        fill='none'
        height='12'
        viewBox='0 0 12 12'
        width='12'
        xmlns='http://www.w3.org/2000/svg'>
        <path d='M0.75 5H11.25V7H0.75V5Z' fill='currentColor' />
    </svg>
);

export default MinusIcon;
